module.exports = __webpack_public_path__ + "media/images/icon_baseinfo_room-9819e48e24c06cdc0fca98f8cb1ed773.png";